import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Event } from './Event';
import { EVENTS_I_AM_ADMIN_OF, EVENTS_I_HOST } from './SecurityRules';

export interface TicketRow {
  id: number;
  event_id: number;
  title: string;
  price: number;
  quantity: number;
}

export const Ticket: Entity<TicketRow> = {
  id: 'Ticket',
  title: 'Ticket',
  service: 'main',
  rowLabel: (row: TicketRow) => row.title,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.ticket',
  },
  security: [
    {
      role: 'user',
      action: 'read',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_HOST}`,
    },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_AM_ADMIN_OF}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    event_id: {
      seq: 15,
      label: 'Event',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: Event,
    },
    title: {
      seq: 15,
      label: 'Title',
      type: FieldType.Text,
      mandatory: true,
      listColumn: true,
    },
    price: {
      seq: 15,
      label: 'Price',
      type: FieldType.Decimal,
      staticPrefix: '£',
      decimalDigits: 2,
      mandatory: true,
      listColumn: true,
    },
    quantity: {
      seq: 20,
      label: 'Quantity',
      type: FieldType.Integer,
      mandatory: true,
      listColumn: true,
    },
  },
};
